import styled from '@emotion/styled';
import _Link from 'next/link';

// next/link statt next-intl-Link: die hrefs aus resolveRoute tragen das Locale-Präfix bereits.
const Link = styled(_Link)({
  textDecoration: 'none',
  color: 'inherit',
});

const ExternalLink = styled.a({
  textDecoration: 'none',
  color: 'inherit',
});

export const S = {
  Link,
  ExternalLink,
} as const;
